import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "isSticky", "isStacked", "data-cell-id"];
import React from 'react';
import { View } from '@instructure/ui-view';
export var RowHeader = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    isSticky = _ref.isSticky,
    isStacked = _ref.isStacked,
    dataCellId = _ref['data-cell-id'],
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(View, Object.assign({
    borderWidth: "0 0 small 0",
    overflowX: "auto",
    as: isStacked ? 'div' : 'th',
    role: isStacked ? 'rowheader' : void 0,
    scope: "row",
    position: isSticky ? 'sticky' : 'static',
    stacking: "topmost",
    insetInlineStart: isSticky ? '0' : void 0,
    background: isSticky && !props.background ? 'primary' : props.background,
    focusPosition: "inset",
    "data-cell-id": dataCellId
  }, props), children);
});
RowHeader.displayName = 'RowHeader';